export enum ApprovalStatus {
  UNRESPONDED = 'UNRESPONDED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
